<template>
	<div class="bulk-actions">
		<select v-model="key">
			<option value="none">Bulk Actions</option>
			<option value="archive">Archive</option>
			<option value="trash">Trash</option>
		</select>
		<core-button
			:disabled="!isBulk || 'none' === key"
			color="white"
			size="small"
			type="secondary"
			button-type="button"
			@click="doBulkAction"
			>Apply</core-button
		>
	</div>
</template>

<script lang="js">
/**
 * Campaign Table Bulk Actions
 *
 * @since 2.0.0
 */
export default {
	inheritAttrs: false,
	props: {
		/**
		 * The Bulk Action key
		 */
		actionKey: {
			type: String,
			default: '',
		},
		/**
		 * Whether we are in bulk edit mode.
		 */
		isBulk: Boolean,
	},
	data() {
		return {
			key: this.actionKey || 'none',
		};
	},
	watch: {
		actionKey() {
			this.key = this.actionKey || 'none';
		},
		key(newVal) {
			this.$emit('setAction', newVal);
		},
	},
	methods: {
		doBulkAction() {
			if ('none' !== this.key) {
				this.$modal.show(`bulk-${this.key}-modal`);
			}
		},
	},
};
</script>
